export const exchangeType = [
  {
    key: "Binance",
    value: "1",
  },
  {
    key: "BingX",
    value: "2",
  },
];

export const BinanceType='1'
export const BingXType='2'

export const tradePositionTypeArr = [
  {
    key: "Position",
    value: "Position",
  },
  {
    key: "PendingOrder",
    value: "PendingOrder",
  },
  {
    key: "Trade",
    value: "Trade",
  },
];

export const orderTypeArr = [
  {
    key: "MARKET",
    value: "MARKET",
  },
  {
    key: "LIMIT",
    value: "LIMIT",
  },
  {
    key: "TRIGGER",
    value: "TRIGGER",
  },
];

export const tiggerbinanceTypeArr = [
  {
    key: "MARKET",
    value: "STOP_MARKET",
  },
  {
    key: "LIMIT",
    value: "STOP",
  },
];


export const tiggerbingxTypeArr = [
  {
    key: "MARKET",
    value: "TRIGGER_MARKET",
  },
  {
    key: "LIMIT",
    value: "TRIGGER_LIMIT",
  },
];

export const tradeType={
  "Open":"Open",
  "Close":"Close"
}

export const exchangeObj={
  "1":"Binance",
  "2":"BingX"
}

export const imagemin = 5;
export const imagemax = 5250;

export const parseDate = (dateString) => {
  let parsedDate = new Date(dateString);
  if (!isNaN(parsedDate)) {
    parsedDate.setHours(0, 0, 0, 0);
    return parsedDate;
  }
  if (dateString.includes(",")) {
    const datePart = dateString.split(",")[0]; // "28 Nov 2024"
    parsedDate = new Date(datePart);
  } else if (dateString.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
    const [date, time] = dateString.split(" ");
    parsedDate = new Date(`${date}T${time}`);
  }

  return isNaN(parsedDate) ? null : parsedDate;
};
